import {
  CardPaymentRedirectRequest,
  CardPaymentRedirectResponse,
} from '@dgx-pr-spa/shared/util';
import { ActionError } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const loadCardPaymentRedirect = createAction(
  '[Complete Order] Load Card Payment Redirect',
  props<{
    payload: {
      request: CardPaymentRedirectRequest;
      addressChanged: boolean;
    };
  }>()
);

export const loadCardPaymentRedirectSuccess = createAction(
  '[Complete Order] Load Card Payment Redirect Success',
  props<{
    payload: {
      request: CardPaymentRedirectRequest;
      response: CardPaymentRedirectResponse;
      addressChanged: boolean;
    };
  }>()
);

export const loadCardPaymentRedirectFail = createAction(
  '[Complete Order] Load Card Payment Redirect Fail',
  props<{ payload: ActionError }>()
);

export const clearPaymentRedirect = createAction(
  '[Complete Order] Clear Card Payment'
);

export type CardPaymentRedirectActions =
  | typeof loadCardPaymentRedirect
  | typeof loadCardPaymentRedirectSuccess
  | typeof loadCardPaymentRedirectFail
  | typeof clearPaymentRedirect;
